import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-menu',
  templateUrl: './dialog-delete-menu.component.html',
  styleUrls: ['./dialog-delete-menu.component.css']
})
export class DialogDeleteMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
